import { Component } from '@angular/core';
import { Platform, Events, LoadingController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { UserService } from '../providers/user-service';
import { PreferencesService } from '../providers/preferences-service';
import { PodcastService } from '../providers/podcast-service';
import { SubscriptionService } from '../providers/subscription-service';
import { AudioService } from '../providers/audio-service';
import { ControlsService } from '../providers/controls-service';

import { PodcastListPage } from '../pages/podcast-list/podcast-list';
import { SignInPage } from '../pages/sign-in/sign-in';

import { API_TIMEOUT } from '../providers/config';

@Component({
  templateUrl: 'app.html',
  providers: [
    UserService,
    PreferencesService,
    PodcastService,
    SubscriptionService,
    AudioService,
    ControlsService
  ]
})

export class MyApp {
  rootPage: any = SignInPage;
  preferences = null;
  displayPlayer = false;

  constructor(
    public platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen,
    public events: Events, public loadingCtrl: LoadingController,
    public userService: UserService, public preferencesService: PreferencesService,
    public audioService: AudioService
  ) {
    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();
      console.log('App Component Platform Ready!');
      // listening for events
      events.subscribe('user:login', () => {
        this.userLoggedIn();
      });
      events.subscribe('user:logout', () => {
        this.userLoggedOut();
      });
      // checking if any authData to persist
      // if so simulate login on start
      this.userService.loadAuthData({ onLaunch: true });
    });
  }

  userLoggedIn() {
    this.platform.ready().then(() => {
      // display loader
      let loader = this.loadingCtrl.create({
        content: 'Loading your preferences...',
        duration: API_TIMEOUT
      });
      loader.present();
      // fetching user prefs
      this.preferencesService.load().subscribe(data => {
        this.preferences = data;

        // Get last playback object
        this.userService.fetchLastPlaybackData().subscribe((playback) => {
          if ((playback) && (playback._episode) && (playback._episode._id)) {
            // Load track
            var track = {
              _id: playback._episode._id,
              src: playback._episode.linkUrl,
              title: playback._episode.title,
              artist: 'n/a',
              art: 'n/a',
              preload: 'metadata'
            };
            this.audioService.playTrack(track, true);
          }
          // pushing podcast list now that we're logged in
          this.rootPage = PodcastListPage;
          this.displayPlayer = true;
          loader.dismiss();
        });
      });
    });
  }

  userLoggedOut() {
    this.userService.clearAuthData();
    this.displayPlayer = false;
    this.rootPage = SignInPage;
  }

  onTrackFinished(track: any) {
    this.events.publish('track:finished');
  }

  playPauseCurrentTrack($event) {
    this.events.publish('track:playpause');
  }

  back30s($event) {
    this.events.publish('track:back30s');
  }

  skip30s($event) {
    this.events.publish('track:skip30s');
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts